export default "__VITE_ASSET__ByaduY80__"